
import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import { setBreadcrumbItems } from "../../store/actions";


const API = process.env.REACT_APP_API;

const FormularioAlta = (props) => {

console.log(API)

  document.title = "Alta | Atletico Minero - Ges Sindical";

  const breadcrumbItems = [
    { title: "Socios", link: "#" },
    { title: "Alta", link: "#" },
  ];

  useEffect(() => {
    props.setBreadcrumbItems('Alta', breadcrumbItems);
  }, []);

  const initialForm = {
    name: '',
    img: '',
    email: '',
    celular: '',
    celular2: '',
    fechaNacimiento: '',
    genero: '',
    direccion: '',
    departamento: '',
    padre: '',
    madre: '',
    documento: '',
    observaciones: '',
    rateId: '',
    siblings: [],
    discountIds: [],
    isPaymentResponsible: false,
    membershipStatus: 'activo'
  };

  const [formData, setFormData] = useState(initialForm);
  const [rates, setRates] = useState([]);
  const [sociosDisponibles, setSociosDisponibles] = useState([]);
  const [descuentosDisponibles, setDescuentosDisponibles] = useState([]);

  const tarifas = API+'/api/rates'
  const socios = API+'/api/members'
  const descuentos = API+'/api/discounts'
  useEffect(() => {
    fetch(tarifas)
      .then(res => res.json())
      .then(data => setRates(data))
      .catch(err => console.error("Error al cargar tarifas:", err));

    fetch(socios)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          const activosOrdenados = data
            .filter(m => m.status === "activo" && m.id && m.name)
            .sort((a, b) => b.id.localeCompare(a.id));
          setSociosDisponibles(activosOrdenados);
        }
      })
      .catch(err => console.error("Error al cargar socios:", err));

    fetch(descuentos)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          const activos = data.filter(d => d.isActive);
          setDescuentosDisponibles(activos);
        }
      })
      .catch(err => console.error("Error al cargar descuentos:", err));
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value
    });
  };

  const toggleHermano = (id) => {
    const existe = formData.siblings.includes(id);
    const nuevos = existe
      ? formData.siblings.filter(sid => sid !== id)
      : [...formData.siblings, id];
    setFormData({ ...formData, siblings: nuevos });
  };

  // Chips para descuentos múltiples
  const toggleDescuento = (id) => {
    const existe = formData.discountIds.includes(id);
    const nuevos = existe
      ? formData.discountIds.filter(did => did !== id)
      : [...formData.discountIds, id];
    setFormData({ ...formData, discountIds: nuevos });
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const obligatorios = ['name', 'email', 'celular', 'fechaNacimiento', 'genero', 'documento'];
  //   const labels = {
  //     name: "Nombre",
  //     email: "Email",
  //     celular: "Celular",
  //     fechaNacimiento: "Fecha de Nacimiento",
  //     genero: "Género",
  //     documento: "Documento"
  //   };

  //   const faltan = obligatorios.filter(f => !formData[f]);
  //   if (faltan.length > 0) {
  //     Swal.fire({
  //       icon: 'warning',
  //       title: 'Faltan campos obligatorios',
  //       text: `Debes completar: ${faltan.map(f => labels[f]).join(', ')}`,
  //     });
  //     return;
  //   }

  //   // payload ya trae discountIds como array
  //   const payload = { ...formData };

  //   try {
  //     const res = await fetch("https://asijeminapis.website:5248/api/members", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(payload)
  //     });

  //     const data = await res.json();
  //     if (res.ok) {
  //       Swal.fire({
  //         icon: 'success',
  //         title: 'Socio creado correctamente',
  //         showConfirmButton: false,
  //         timer: 1800
  //       });
  //       setFormData(initialForm);

  //       fetch("https://asijeminapis.website:5248/api/members")
  //         .then(res => res.json())
  //         .then(data => {
  //           if (Array.isArray(data)) {
  //             setSociosDisponibles(data.filter(m => m.status === "activo" && m.id && m.name));
  //           }
  //         })
  //         .catch(err => console.error("Error al cargar socios:", err));
  //     }
  //     else {
  //       Swal.fire({
  //         icon: 'error',
  //         title: 'Error al crear socio',
  //         text: data.error || "Intente nuevamente.",
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error al guardar socio:", error);
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Error de red',
  //       text: 'No se pudo conectar con el servidor.',
  //     });
  //   }
  // };



  const handleSubmit = async (e) => {
  e.preventDefault();

  const obligatorios = ['name', 'email', 'celular', 'fechaNacimiento', 'genero', 'documento'];
  const labels = {
    name: "Nombre",
    email: "Email",
    celular: "Celular",
    fechaNacimiento: "Fecha de Nacimiento",
    genero: "Género",
    documento: "Documento"
  };

  const faltan = obligatorios.filter(f => !formData[f]);
  if (faltan.length > 0) {
    Swal.fire({
      icon: 'warning',
      title: 'Faltan campos obligatorios',
      text: `Debes completar: ${faltan.map(f => labels[f]).join(', ')}`,
    });
    return;
  }

  // Convertir discountIds a formato esperado por el backend
  const hoy = new Date();
  const tresMesesDespues = new Date();
  tresMesesDespues.setMonth(hoy.getMonth() + 3);

  const descuentosFormateados = formData.discountIds.map(id => ({
    discountId: id,
    fechaInicio: hoy,
    fechaFin: tresMesesDespues,
    activo: true
  }));

  const payload = {
    ...formData,
    discounts: descuentosFormateados
  };

  delete payload.discountIds; // eliminar el campo viejo

  try {
    // const res = await fetch("https://asijeminapis.website:5248/api/members", {
       const res = await fetch(`${API}/api/members`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    const data = await res.json();
    if (res.ok) {
      Swal.fire({
        icon: 'success',
        title: 'Socio creado correctamente',
        showConfirmButton: false,
        timer: 1800
      });
      setFormData(initialForm);

      fetch(`${API}/api/members`)
        .then(res => res.json())
        .then(data => {
          if (Array.isArray(data)) {
            setSociosDisponibles(data.filter(m => m.status === "activo" && m.id && m.name));
          }
        })
        .catch(err => console.error("Error al cargar socios:", err));
    }
    else {
      Swal.fire({
        icon: 'error',
        title: 'Error al crear socio',
        text: data.error || "Intente nuevamente.",
      });
    }
  } catch (error) {
    console.error("Error al guardar socio:", error);
    Swal.fire({
      icon: 'error',
      title: 'Error de red',
      text: 'No se pudo conectar con el servidor.',
    });
  }
};




  return (
    <div className="container mt-4">
      <h2 className="mb-4">Alta de Socio</h2>
      <form onSubmit={handleSubmit}>
        <div className="row">

          {/* Datos personales */}
          <div className="col-md-4 mb-3">
            <label>Nombre completo *</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} className="form-control" />
          </div>
          <div className="col-md-4 mb-3">
            <label>Fecha de Nacimiento *</label>
            <input type="date" name="fechaNacimiento" value={formData.fechaNacimiento} onChange={handleChange} className="form-control" />
          </div>
          <div className="col-md-4 mb-3">
            <label>Género *</label>
            <select name="genero" value={formData.genero} onChange={handleChange} className="form-control">
              <option value="">Seleccione</option>
              <option value="masculino">Masculino</option>
              <option value="femenino">Femenino</option>
            </select>
          </div>

          {/* Contacto */}
          <div className="col-md-4 mb-3">
            <label>Email *</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} className="form-control" />
          </div>
          <div className="col-md-4 mb-3">
            <label>Celular *</label>
            <input type="text" name="celular" value={formData.celular} onChange={handleChange} className="form-control" />
          </div>
          <div className="col-md-4 mb-3">
            <label>Segundo Celular</label>
            <input type="text" name="celular2" value={formData.celular2} onChange={handleChange} className="form-control" />
          </div>

          {/* Domicilio */}
          <div className="col-md-6 mb-3">
            <label>Dirección</label>
            <input type="text" name="direccion" value={formData.direccion} onChange={handleChange} className="form-control" />
          </div>
          <div className="col-md-6 mb-3">
            <label>Departamento</label>
            <input type="text" name="departamento" value={formData.departamento} onChange={handleChange} className="form-control" />
          </div>

          {/* Padres */}
          <div className="col-md-6 mb-3">
            <label>Padre</label>
            <input type="text" name="padre" value={formData.padre} onChange={handleChange} className="form-control" />
          </div>
          <div className="col-md-6 mb-3">
            <label>Madre</label>
            <input type="text" name="madre" value={formData.madre} onChange={handleChange} className="form-control" />
          </div>

          {/* Documento y tarifa */}
          <div className="col-md-6 mb-3">
            <label>Documento *</label>
            <input type="text" name="documento" value={formData.documento} onChange={handleChange} className="form-control" />
          </div>
          <div className="col-md-6 mb-3">
            <label>Tarifa *</label>
            <select name="rateId" value={formData.rateId} onChange={handleChange} className="form-control">
              <option value="">Seleccione una tarifa</option>
              {rates.map(rate => (
                <option key={rate._id} value={rate._id}>
                  {rate.name} - <span className='font-weight-bold'>${rate.amount}</span> 
                </option>
              ))}
            </select>
          </div>

          {/* Hermanos */}
          <div className="col-md-12 mb-3">
            <label>Hermanos (opcional)</label>
            <div className="border rounded p-2" style={{ maxHeight: '200px', overflowY: 'auto' }}>
              {Array.isArray(sociosDisponibles) && sociosDisponibles.length > 0 ? (
                sociosDisponibles.map((socio) => {
                  const id = String(socio.id); // Usamos "id" del DTO
                  const isChecked = formData.siblings.includes(id);
                  return (
                    <div key={id} className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`sibling-${id}`}
                        value={id}
                        checked={isChecked}
                        onChange={() => toggleHermano(id)}
                      />
                      <label className="form-check-label" htmlFor={`sibling-${id}`}>
                        {socio.name} - {socio.documento || socio.email || "Sin documento"}
                      </label>
                    </div>
                  );
                })
              ) : (
                <div className="text-muted">No hay socios activos disponibles.</div>
              )}
            </div>
          </div>

          {/* Descuentos tipo chips */}
          <div className="col-md-12 mb-3">
            <label>Descuentos (puede elegir varios):</label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '8px' }}>
              {descuentosDisponibles.map(desc => {
                const selected = formData.discountIds.includes(desc._id);
                return (
                  <span
                    key={desc._id}
                    onClick={() => toggleDescuento(desc._id)}
                    style={{
                      cursor: 'pointer',
                      padding: '8px 16px',
                      borderRadius: '16px',
                      background: selected ? '#03a9f4' : '#e0e0e0',
                      color: selected ? 'white' : '#333',
                      boxShadow: selected ? '0 2px 4px #0288d1' : 'none',
                      userSelect: 'none'
                    }}
                  >
                    {desc.name} ({desc.percentage}%)
                    {selected && (
                      <span style={{ marginLeft: 8, fontWeight: 'bold', fontSize: 18 }}>×</span>
                    )}
                  </span>
                );
              })}
              {descuentosDisponibles.length === 0 && (
                <span className="text-muted">No hay descuentos cargados.</span>
              )}
            </div>
          </div>

          {/* Observaciones */}
          <div className="col-md-12 mb-3">
            <label>Observaciones</label>
            <textarea name="observaciones" value={formData.observaciones} onChange={handleChange} className="form-control" />
          </div>

          {/* Responsable de pago */}
          <div className="col-md-12 form-check mb-4">
            <input type="checkbox" name="isPaymentResponsible" checked={formData.isPaymentResponsible} onChange={handleChange} className="form-check-input" id="responsablePago" />
            <label className="form-check-label" htmlFor="responsablePago">Es responsable de pago</label>
          </div>

          <div className="col-12 text-end">
            <button type="submit" className="btn btn-primary">Guardar Socio</button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(FormularioAlta);
